import React from "react";
import {Modal} from "react-bootstrap";


const ModalPopUp = (props) => {
     return (
        <Modal
            size="xl"
            show={props.showModal}
            onHide={props.hideModal}
            aria-labelledby="example-modal-sizes-title-lg"
            className="modal_box"
            >
            <Modal.Header closeButton>
            <Modal.Title id="modal_box_header">
                {props.title}
            </Modal.Title>
            </Modal.Header>
            <Modal.Body className={props.class}>
                {props.component}
            </Modal.Body>
      </Modal>
     )
}

export default ModalPopUp;